module.exports = __webpack_public_path__ + "img/段世杰@2x.23f6376a.png";